import IMAGES from './assets';

export const VALUES_LIST = IMAGES.map((illustration, i) => {
    const copySlug = `logo_maker_perseus.buyer_landing_page.create_logo_value_points.value_${i + 1}`;

    return {
        title: `${copySlug}.title`,
        alt: `${copySlug}.alt`,
        body: `${copySlug}.body`,
        illustration,
    };
});
